import * as React from 'react'
import { styled } from '@mui/material/styles'
import _ from 'lodash'

import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import CardActionArea from '@mui/material/CardActionArea'
import Stack from '@mui/material/Stack'
import { useTheme } from '@mui/material'

import { I18n, useTranslation } from 'components/hooks/use-translation'
import ProgressBar from 'components/atomic/atoms/progress-bar'
import Button from 'components/atomic/atoms/button'
import Text from 'components/atomic/atoms/text'
import Icon from 'components/atomic/atoms/icon'
import Card from 'components/atomic/atoms/card'
import Chip from 'components/atomic/atoms/chip'

import * as PathsUtils from 'utils/paths'
import { PathGoal } from 'types/types'

const CardContent = styled('div')`
    min-height: 7rem;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    position: relative;
    z-index: 1;
    top: 0;
    left: 0;
    &:hover {
        cursor: pointer;
    }
`

interface ProgressCardProps {
    type: PathGoal
    to: string
    title: string
    time_to_complete: number
    percent_complete: number
}

const ProgressCard = React.memo((props: ProgressCardProps) => {
    const { t }: I18n = useTranslation()
    const { palette } = useTheme()

    const colors = React.useMemo(() => PathsUtils.colorsFromItemType(props.type), [props.type])

    return (
        <CardActionArea sx={{ height: '100%' }}>
            <Card to={`${props.to}`}>
                <CardContent>
                    <Stack direction="row" justifyContent="space-between" alignItems="baseline" spacing={2}>
                        <Text variant="h6">{_.truncate(props.title, { length: 45 })}</Text>
                        <Chip
                            size="small"
                            variant="outlined"
                            label={t(`common:pathGoal.${props.type}`)}
                            sx={{ borderColor: colors[0], backgroundColor: colors[1] }}
                        />
                    </Stack>
                    <Stack spacing="0.3rem">
                        <Stack direction="row" justifyContent="space-between" alignItems="center">
                            <Stack direction="row" alignItems="center" spacing="0.2rem">
                                <Icon sx={{ color: palette.text.secondary }} fontSize="small" name="time" />
                                <Text color="text.secondary" variant="caption">{`${Math.ceil(
                                    props.time_to_complete / 60,
                                )} ore rimanenti`}</Text>
                            </Stack>
                            <Button endIcon={<ChevronRightIcon />}>
                                <Text variant="caption">{t('paths:continue')}</Text>
                            </Button>
                        </Stack>
                        <ProgressBar type="outlined" variant="determinate" value={props.percent_complete} />
                    </Stack>
                </CardContent>
            </Card>
        </CardActionArea>
    )
})

export default ProgressCard
